import React from 'react';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { FileOutput, Settings, UserCircle2 } from 'lucide-react';
import usecustomStyles from '../Common/customStyles';

const customStyles = usecustomStyles();
const { Text } = Typography;

const StyleFlagDropdown = styled.div`
  min-width:145px;

  ul {
    li {
        padding: 5px 0;
        a {
            transition: all 0.5s ease;
            &:hover {
                color: ${customStyles.colorPrimary};
            }
        }
    }
  }
`;

const getProfileContentPopover = (userId, username) => (
    <StyleFlagDropdown>
        <ul style={{ padding: "6px", listStyleType: "none" }} className='ant-pl-0 ant-mb-0'>
            <li>
                <Link to={`/users/${userId}`}>
                    <Text type="secondary"><UserCircle2 className='ant-mr-1' size={16} /></Text><Text> {username}</Text>
                </Link>
            </li>
            <li>
                <Link to="/org_settings">
                    <Text type="secondary"> <Settings className='ant-mr-1' size={16} /></Text><Text> Organizacija</Text>
                </Link>
            </li>
            <li>
                <Link to="/logout">
                    <Text type="secondary"> <FileOutput className='ant-mr-1' size={16} /></Text><Text> Odjava</Text>
                </Link>
            </li>
        </ul>
    </StyleFlagDropdown>
);

export { getProfileContentPopover, StyleFlagDropdown };
